import Reveal from './Reveal'

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ backgroundImage: 'url(/hero.svg)', backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/40 to-slate-950/80" />
      <div className="relative mx-auto max-w-7xl px-4 py-28">
        <Reveal
          once={false}
          enterThreshold={0.65}
          exitThreshold={0.35}
          rootMargin="-96px 0px -25% 0px"
        >
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight">
            Innovative Web & Cloud Lösungen
          </h1>
        </Reveal>

        <Reveal
          delayMs={120}
          y={12}
          once={false}
          enterThreshold={0.65}
          exitThreshold={0.35}
          rootMargin="-96px 0px -25% 0px"
        >
          <p className="mt-6 max-w-2xl text-lg text-slate-300">
            Zu zweit sind wir die M2 Wbsolutions GBR und setzen auf den MERN-Stack und moderne Cloud-Technologien, um stabile und sichere Anwendungen zu entwickeln –
             individuell nach den Wünschen und Zielen unserer Kunden.
          </p>
        </Reveal>

        <Reveal
          delayMs={220}
          y={12}
          once={false}
          enterThreshold={0.65}
          exitThreshold={0.35}
          rootMargin="-96px 0px -25% 0px"
        >
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="/projects" className="rounded-xl bg-brand-500 px-5 py-3 font-semibold hover:bg-brand-400 transition shadow-[0_10px_30px_rgba(0,0,0,0.25)]">Unsere Projekte</a>
            <a href="/nft-hub" className="rounded-xl border border-white/20 px-5 py-3 font-semibold hover:bg-white/10 transition">Zum NFT-Hub</a>
          </div>
        </Reveal>
      </div>
    </section>
  )
}
